export default __webpack_public_path__ + "static/media/analyzing.89674587.svg";